(function() {
  function applyPlaybackRate(container) {
    var rate = parseFloat(container.getAttribute('data-playback-speed'));
    if (isNaN(rate) || rate <= 0) return;
    var video = container.querySelector('video');
    if (!video) return;
    if (video.readyState >= 1) {
      video.playbackRate = rate;
    } else {
      video.addEventListener('loadedmetadata', function() {
        video.playbackRate = rate;
      });
    }
    video.addEventListener('play', function() {
      video.playbackRate = rate;
    });
  }

  function initAll(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('[data-playback-speed]');
    containers.forEach(function(container) {
      applyPlaybackRate(container);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();